export default __webpack_public_path__ + "static/pool-forme3-512a98617a067cdaeaf5cb09f3c60054.svg";